import { useEffect, useState } from 'react'
import { Link, NavLink } from 'react-router-dom'

import { mixOther } from 'api/mixOther'

type Home = {
  meta_title: string;
  meta_description: string;
  meta_keywords: string;
  images_banner: string;
  link_banner: string;
};

const CACHE_KEY_SSHOME = 'app_sshome_cache';

function getCachedHome(): Partial<Home> | null {
  try {
    const raw = localStorage.getItem(CACHE_KEY_SSHOME);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

function setCachedHome(data: Partial<Home>): void {
  try {
    localStorage.setItem(CACHE_KEY_SSHOME, JSON.stringify({
      images_banner: data.images_banner,
      link_banner: data.link_banner,
    }));
  } catch {}
}

export default function Sidebar({ onToggleNotify }: { onToggleNotify: () => void }) {

  const [home, setHome] = useState<Home | null>(() => {
    const cached = getCachedHome();
    return cached ? (cached as Home) : null;
  })
        
  useEffect(() => {
      const loadOther = async () => {
          const res = await mixOther("sshome","vi")
              if (!res?.status || !res.data?.json) {
              return;
          }

          try {
              const parsed = JSON.parse(res.data.json);
              setHome((prev) => ({ ...prev, ...parsed }));
              setCachedHome(parsed);
          } catch (error) {
              console.error("Failed to parse setting JSON:", error);
          }
      };

      loadOther();
  }, [])

  return (
    <div className="styles_containerHeader__qmsyu hidden-1199">
      <div className="styles_topMenuContainer__0sPLC bg-gradient">
        <div className="styles_headerTop__cWk5j">
          <div className="styles_wrapperLink__VBuUw">
            {/* <a
              className="styles_linkMenu__8r7wM"
              target="_blank"
              href="https://hoptacbanhang.thuocsi.vn?utm_source=website&amp;utm_medium=topbutton&amp;utm_campaign=website_ref&amp;utm_term=202305" rel="noreferrer"
            >
              <span
              style={{
                boxSizing: 'border-box',
                display: 'inline-block',
                overflow: 'hidden',
                width: '24px',
                height: '24px',
                background: 'none',
                opacity: 1,
                border: '0px',
                margin: '0px',
                padding: '0px',
                position: 'relative',
              }}
              >
                <img
                  data-origin-url="https://cdn-web-next.thuocsi.vn/images/home/home.svg"
                  src="https://cdn-web-next.thuocsi.vn/images/home/home.svg"
                  decoding="async"
                  data-nimg="fixed"
                  alt="Home"
                  style={{
                    position: 'absolute',
                    inset: '0px',
                    boxSizing: 'border-box',
                    padding: '0px',
                    border: 'none',
                    margin: 'auto',
                    display: 'block',
                    width: '0px',
                    height: '0px',
                    minWidth: '100%',
                    maxWidth: '100%',
                    minHeight: '100%',
                    maxHeight: '100%',
                  }} /><noscript></noscript
                >
              </span>
              <p className="MuiTypography-root MuiTypography-body2">Đăng ký bán hàng</p>
            </a> */}
            <NavLink
              className={({ isActive }) => `styles_linkMenu__8r7wM${isActive ? ' active' : ''}`}
              to="/huong-dan"
            ><span
              style={{
                boxSizing: 'border-box',
                display: 'inline-block',
                overflow: 'hidden',
                width: '24px',
                height: '24px',
                background: 'none',
                opacity: 1,
                border: '0px',
                margin: '0px',
                padding: '0px',
                position: 'relative',
              }}
            ><img
                  data-origin-url="https://cdn-web-next.thuocsi.vn/images/home/help.svg"
                  src="https://cdn-web-next.thuocsi.vn/images/home/help.svg"
                  decoding="async"
                  data-nimg="fixed"
                  alt="Help"
                  style={{
                    position: 'absolute',
                    inset: '0px',
                    boxSizing: 'border-box',
                    padding: '0px',
                    border: 'none',
                    margin: 'auto',
                    display: 'block',
                    width: '0px',
                    height: '0px',
                    minWidth: '100%',
                    maxWidth: '100%',
                    minHeight: '100%',
                    maxHeight: '100%',
                  }} /><noscript></noscript
                  ></span>
              <p className="MuiTypography-root MuiTypography-body2">Hướng dẫn đặt hàng</p></NavLink
            ><NavLink className={({ isActive }) => `styles_linkMenu__8r7wM${isActive ? ' active' : ''}`} to="/user/wishlist"
            ><span
              style={{
                boxSizing: 'border-box',
                display: 'inline-block',
                overflow: 'hidden',
                width: '24px',
                height: '24px',
                background: 'none',
                opacity: 1,
                border: '0px',
                margin: '0px',
                padding: '0px',
                position: 'relative',
              }}
            ><img
                  data-origin-url="https://cdn-web-next.thuocsi.vn/images/home/heart.svg"
                  src="https://cdn-web-next.thuocsi.vn/images/home/heart.svg"
                  decoding="async"
                  data-nimg="fixed"
                  alt="Heart"
                  style={{
                    position: 'absolute',
                    inset: '0px',
                    boxSizing: 'border-box',
                    padding: '0px',
                    border: 'none',
                    margin: 'auto',
                    display: 'block',
                    width: '0px',
                    height: '0px',
                    minWidth: '100%',
                    maxWidth: '100%',
                    minHeight: '100%',
                    maxHeight: '100%',
                  }} /><noscript></noscript
                  ></span>
              <p className="MuiTypography-root MuiTypography-body2">Sản phẩm quan tâm</p></NavLink
            >
          </div>
          <div className="styles_wrapperLink__VBuUw">
            <button onClick={onToggleNotify} className="MuiButtonBase-root styles_notiContainer__6m2CD" tabIndex={0} type="button">
              <div className="styles_badgeContainer__wVKFh">
                <span
                  style={{
                    boxSizing: 'border-box',
                    display: 'inline-block',
                    overflow: 'hidden',
                    width: '14px',
                    height: '18px',
                    background: 'none',
                    opacity: 1,
                    border: '0px',
                    margin: '0px',
                    padding: '0px',
                    position: 'relative',
                  }}
                ><img
                    data-origin-url="https://cdn-web-next.thuocsi.vn/images/home/noti.svg"
                    src="https://cdn-web-next.thuocsi.vn/images/home/noti.svg"
                    decoding="async"
                    data-nimg="fixed"
                    alt="Notification"
                    style={{
                      position: 'absolute',
                      inset: '0px',
                      boxSizing: 'border-box',
                      padding: '0px',
                      border: 'none',
                      margin: 'auto',
                      display: 'block',
                      width: '0px',
                      height: '0px',
                      minWidth: '100%',
                      maxWidth: '100%',
                      minHeight: '100%',
                      maxHeight: '100%',
                    }} /><noscript></noscript
                    ></span>
              </div>
              <span className="styles_titleNoti__To2Qd">Thông báo</span>
              <span className="MuiTouchRipple-root"></span>
            </button>
            {/* <a className="styles_linkMenu__8r7wM" target="_blank" href="https://news.thuocsi.vn" rel="noreferrer">
              <span
                style={{
                  boxSizing: 'border-box',
                  display: 'inline-block',
                  overflow: 'hidden',
                  width: '24px',
                  height: '24px',
                  background: 'none',
                  opacity: 1,
                  border: '0px',
                  margin: '0px',
                  padding: '0px',
                  position: 'relative',
                }}
              ><img
                  data-origin-url="https://cdn-web-next.thuocsi.vn/images/home/paper.svg"
                  src="https://cdn-web-next.thuocsi.vn/images/home/paper.svg"
                  decoding="async"
                  data-nimg="fixed"
                  alt="Paper"
                  style={{
                    position: 'absolute',
                    inset: '0px',
                    boxSizing: 'border-box',
                    padding: '0px',
                    border: 'none',
                    margin: 'auto',
                    display: 'block',
                    width: '0px',
                    height: '0px',
                    minWidth: '100%',
                    maxWidth: '100%',
                    minHeight: '100%',
                    maxHeight: '100%',
                  }} /><noscript></noscript
                  ></span>
              <p className="MuiTypography-root MuiTypography-body2">Tin tức</p>
            </a> */}
            {/* <a className="styles_linkMenu__8r7wM" target="_blank" href="https://career.buymed.com" rel="noreferrer"
            >
              <span
              style={{
                boxSizing: 'border-box',
                display: 'inline-block',
                overflow: 'hidden',
                width: '24px',
                height: '24px',
                background: 'none',
                opacity: 1,
                border: '0px',
                margin: '0px',
                padding: '0px',
                position: 'relative',
              }}
              >
                <img
                  data-origin-url="https://cdn-web-next.thuocsi.vn/images/home/hiring.svg"
                  src="https://cdn-web-next.thuocsi.vn/images/home/hiring.svg"
                  decoding="async"
                  data-nimg="fixed"
                  alt="Hiring"
                  style={{
                    position: 'absolute',
                    inset: '0px',
                    boxSizing: 'border-box',
                    padding: '0px',
                    border: 'none',
                    margin: 'auto',
                    display: 'block',
                    width: '0px',
                    height: '0px',
                    minWidth: '100%',
                    maxWidth: '100%',
                    minHeight: '100%',
                    maxHeight: '100%',
                  }} /><noscript></noscript
                  ></span>
              <p className="MuiTypography-root MuiTypography-body2">Tuyển dụng</p>
            </a> */}
          </div>
        </div>
      </div>
      <div className="styles_headerCenter__rkkQJ !p-0">
        <a
          className="styles_mobile_rootBase__8z7PQ"
          href={home?.link_banner}
          style={{ padding: '0px' }}
        >
          <div className="styles_countdownBarFullWrapper__H__ia" style={{ backgroundColor: 'rgb(255, 255, 255)' }}>
            <span
              style={{
                boxSizing: 'border-box',
                display: 'block',
                overflow: 'hidden',
                width: 'initial',
                height: 'initial',
                background: 'none',
                opacity: 1,
                border: '0px',
                margin: '0px',
                padding: '0px',
                position: 'absolute',
                inset: '0px',
              }}
            ><img
                alt="GTBB - 15.12"
                src={home?.images_banner || undefined}
                decoding="async"
                data-nimg="fill"
                style={{
                  visibility: home?.images_banner ? 'visible' : 'hidden',
                  position: 'absolute',
                  inset: '0px',
                  boxSizing: 'border-box',
                  padding: '0px',
                  border: 'none',
                  margin: 'auto',
                  display: 'block',
                  width: '0px',
                  height: '0px',
                  minWidth: '100%',
                  maxWidth: '100%',
                  minHeight: '100%',
                  maxHeight: '100%',
                }} /><noscript></noscript
                ></span></div
          >
        </a>
      </div>
    </div>
  )
}

